'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isMap = require('is-map');

var isSet = require('is-set');

var isWeakMap = require('is-weakmap');

var isWeakSet = require('is-weakset');

module.exports = function whichCollection(value) {
  if (value && _typeof(value) === 'object') {
    if (isMap(value)) {
      return 'Map';
    }

    if (isSet(value)) {
      return 'Set';
    }

    if (isWeakMap(value)) {
      return 'WeakMap';
    }

    if (isWeakSet(value)) {
      return 'WeakSet';
    }
  }

  return false;
};